import Box from "@mui/material/Box";
import { colors } from "../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";

export default function Number({ n, state }) {
  const { t, locale } = useI18n();

  let leftOrRight = locale === "en" ? "left" : "right";
  return (
    <Box
      component="span"
      sx={{
        bgcolor: state == n ? colors.orange : "grey",
        borderRadius: "50%",
        width: { xs: "20px", sm: "30px", md: "35px" },
        height: { xs: "20px", sm: "30px", md: "35px" },
        fontSize: { xs: "15px", sm: "25px", md: "27px" },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
      }}
    >
      {n}
    </Box>
  );
}
